import React, { useState } from 'react'
import { Button, Form } from 'react-bootstrap'
import { X, Check } from 'react-bootstrap-icons'
import { get, find } from 'lodash'
import { useMutation } from 'react-query'
import userService from '../../../services/api/user'
import useToasts from '../../../hooks/use-toasts'
import useUsers from '../../../hooks/use-users'

const EditGrade = ({
    user = {},
    onClose = () => {}
}) => {
    const [ gradYear, setGradYear] = useState(get(user, 'gradYear', ''))

    const { error: errorToast } = useToasts({
        errorMessage: 'Error updating user.'
    })

    const { reloadUsers } = useUsers({ enabled: false, onReload: onClose })

    const [ updateUser, { isLoading }] = useMutation(() => userService.update({ id: user.id, gradYear }), {
        onError: errorToast,
        onSuccess: reloadUsers
    })


    return (
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div style={{ flexGrow: '0.9', color: 'black' }}>
                <Form.Control type='number' placeholder="Enter Grad Year" value={gradYear} onChange={e => setGradYear(e.target.value)} />
            </div>
            <div style={{ display: 'flex', alignItems: 'center'}}>
                <Button disabled={isLoading} variant='outline-secondary' onClick={() => onClose()} ><X /></Button>
                <Button disabled={isLoading} variant='primary' onClick={() => updateUser()} ><Check /></Button>
            </div>
        </div>
    )
}

export default EditGrade